import React, { useEffect, useState } from "react";
import PropTypes from 'prop-types';
import { getFileTypeExtension } from '../../../../../util/file-helpers';
import { DownloadCommentAttachment, DownloadRegularCommentAttachment } from "../../../../../services/api/task-api";

const getDownloadingEndpoint = async (file, taskId, type) => {
    let response = null;
    let downloadedFileType = getFileTypeExtension(file.fileName);
    let fileDownloadDetails = {
        Id: 0,
        DocumentId: file.documentID,
        AttachmentType: downloadedFileType,
        TaskId: taskId,
        Scroll: "0"
    };

    try {
        if (type === "standard") {
            response = await DownloadRegularCommentAttachment(0, file.mimeType, fileDownloadDetails);
        } else {
            response = await DownloadCommentAttachment(0, file.mimeType, fileDownloadDetails);
        }
        return response ? response : null;
    } catch (error) {
        console.error("Error in getDownloadingEndpoint:", error);
        return response ? response : null;
    }
};

const TiffViewer = ({ file, taskId, type, commentViewer }) => {
    const styleClass = commentViewer ? "show-comment-pdf-viewer" : "no-comment-pdf-viewer";
    const [dataUrI, setDataUrI] = useState(null);

    useEffect(() => {
        if (file && taskId && type) {
            // Guard async state updates against unmount (the download and the
            // dynamic decoder import both resolve later) — same pattern as
            // tasks-page.jsx.
            let isMounted = true;
            getDownloadingEndpoint(file, taskId, type).then(
                async (result) => {
                    if (result && result.data) {
                        const arrayBufferFile = result.data;
                        try {
                            // Browsers cannot render TIFF natively, so decode
                            // to PNG client-side. Dynamic import keeps the
                            // decoder out of the main chunk. Same shared util
                            // as the department logo upload in
                            // admin-department-form-new.jsx.
                            const { tiffToPngDataUrls } = await import(
                                "../../../../../util/tiff-helpers"
                            );
                            // The iframe can hold one data URL, so decode only
                            // the first page (maxPages bounds the synchronous
                            // decode cost for large multi-page scans) — the
                            // same page-1 behavior as the previous decoder.
                            const [firstPage] = tiffToPngDataUrls(arrayBufferFile, 1);
                            if (isMounted) {
                                setDataUrI(firstPage);
                            }
                        } catch (error) {
                            console.log("Error processing TIFF:", error);
                        }
                    } else if (isMounted) {
                        setDataUrI(null);
                    }
                },
                (error) => {
                    console.log("Error [getDownloadingEndpoint] for TIFF file => ", error);
                    if (isMounted) {
                        setDataUrI(null);
                    }
                }
            );
            return () => {
                isMounted = false;
            };
        }
    }, [file, taskId, type]);

    return (
        <iframe
            className={styleClass}
            src={dataUrI}
            title="fileName"
            height="500px"
            width="100%"
            allowFullScreen
            data-testid="tiff-viewer"
        />
    );
};

TiffViewer.propTypes = {
    file: PropTypes.shape({
        mimeType: PropTypes.string.isRequired,
        fileName: PropTypes.string.isRequired,
        thedocAsBytes: PropTypes.any,
        docByteArr: PropTypes.any,
        userID: PropTypes.number,
        documentID: PropTypes.number.isRequired,
        uploadDate: PropTypes.string,
        projectID: PropTypes.number,
        docPath: PropTypes.string
    }).isRequired,
    taskId: PropTypes.number.isRequired,
    type: PropTypes.string.isRequired,
    commentViewer: PropTypes.bool
};

export default TiffViewer;
